export const COMMON_URLS = {
    WEBAPP_ENTRY_POINT: "/webapp/entrypoint",
};